import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategoryItems } from '../../services/api';
import { CategoryValue } from '../../utils/common';

export const fetchCategoryValues = createAsyncThunk('lov/fetchCategoryValues', async () => {
  const data = await getCategoryItems();
  return data;
});

interface CategoryState {
  values: CategoryValue[];
  loading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  values: [],
  loading: false,
  error: null,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryValues.fulfilled, (state, action) => {
        state.values = action.payload;
        state.loading = false;
      })
      .addCase(fetchCategoryValues.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default categorySlice.reducer;